import React, { useState, useEffect } from "react";
import { Divider, Input, Button, notification } from "antd";
import { t } from "i18next";

const PersonalInformationForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const storedInfo = localStorage.getItem("personalInfo");
    if (storedInfo) {
      const { name, email, phone } = JSON.parse(storedInfo);
      setName(name);
      setEmail(email);
      setPhone(phone);
    }
  }, []);

  const handleSave = () => {
    const personalInfo = {
      name: name,
      email: email,
      phone: phone,
    };
    localStorage.setItem("personalInfo", JSON.stringify(personalInfo));
    notification.success({
      message: t("successSave"),
      placement: "top",
    });
  };

  return (
    <div className="personal-information-container">
      <div className="personal-information-form-container">
        <div>
          <div className="personal-information-form-items-container">
            <h1 className="personal-information-heading">
              {t("personalInfo")}
            </h1>
          </div>
          <p className="personal-information-description">
            {t("savePersonalInfoDescription")}
          </p>
          <Divider />

          <div className="personal-information-inputs-container">
            <Input
              className="personal-information-input"
              type="text"
              placeholder={t("name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Input
              className="personal-information-input"
              type="text"
              placeholder={t("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value.replace(/\s/g, ""))}
            />

            <Input
              className="personal-information-input"
              type="text"
              placeholder={t("phone")}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <Button
              className="custom-button personal-information-button"
              type="primary"
              size="large"
              onClick={handleSave}
            >
              {t("save")}
            </Button>
          </div>
        </div>
      </div>
      <div className="personal-information-column-image"></div>
    </div>
  );
};

export default PersonalInformationForm;
